export default __webpack_public_path__ + "static/media/musicsearchcomp.c53d6d70.PNG";